import React, {useState} from 'react';
import Popup from '../../shared/popup';
import Button from '../button';

const InfoPopup: React.FC<{
  title?: string;
  message?: string;
  okCallback: () => void;
  okButtonText?: string;
  visible?: boolean;
}> = ({
  title = "",
  message = "",
  okCallback,
  okButtonText = "",
  visible = true
}) => {
  return (
    <>
      { visible &&
        <Popup noHeader onClose={() => okCallback?.()}>
          <group>
            <group data-space="30" data-direction="column">
              <text
                data-wrap="wrap"
                data-accent=""
                data-text-size="medium"
                data-wrap-line=""
              >
                {title || ""}
              </text>
              <text data-wrap="wrap" data-text-size="medium" data-wrap-line="">
                {message || ""}
              </text>
            </group>
            <group
              data-space="30"
              data-gap="10"
              data-background="highlight"
              data-type="grid"
            >
              <button
                type="button"
                effect="material"
                className="button primary large"
                onClick={() => {
                  okCallback?.();
                }}
              >
                <text>{okButtonText || "Okay"}</text>
              </button>
            </group>
          </group>
        </Popup>
      }
    </>
  );
};
export default InfoPopup;
